import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Option } from '@rivethealth/data/options';
import { Loadable } from '../helpers/loadable';
import { MultiSelectDropdownComponent } from './multi-select-dropdown.component';

@Component({
  selector: 'multi-select-dropdown-field',
  templateUrl: './multi-select-dropdown-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MultiSelectDropdownFieldComponent),
    },
  ],
})
export class MultiSelectDropdownFieldComponent {
  @Input() label: string;
  @Input() help: string;
  @Input() required: boolean;
  @Input() placeholder: string;
  @Input() display: string;
  @Input() disabled: boolean;
  @Input() autoFocus: boolean;
  @Input() exact: boolean;
  @Input() filterable: boolean;
  @Input() loadable: Loadable<any>;
  @Input() options: Option[] | string[];
  @Input() actionText: string;
  @Input() selectedEnabled: boolean = true;
  @Output() valueChange = new EventEmitter();
  @Output() action = new EventEmitter();
  @Output() dropdownStateChange = new EventEmitter();

  @ViewChild('dropdownElement', { static: false })
  dropdownElement: MultiSelectDropdownComponent;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  @Input('value')
  private _value: string;
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
    this.propagateChange(value);
  }

  @Input()
  maxElements: number;

  private propagateChange = (_: any) => {};

  writeValue(value: any) {
    this._value = value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (_: any) => {}) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
    this.cdr.markForCheck();
  }

  public close() {
    this.dropdownElement.close();
  }

  public open() {
    this.dropdownElement.open();
  }

  public focus() {
    (<any>this.dropdownElement).focus();
  }
}
